
  /**
   * Import Lib & assets
   */

  import React from 'react'
  import styled from 'styled-components'
  import PropTypes from 'prop-types';
  import t from 'theme'

  /**
   * import components
   */


  /**
   * styled components
   */

  const Condition = styled.p`
    margin-top: 14px;
    ${t.mixins.rem(13, 13)}
    font-family: ${t.font.primary};
    color: ${t.color.darkGrey};
    max-width: 602px;

    ${t.mixins.sm(`
      padding: 0 25px;
      max-wdith: 317px;
    `)}
  `;

  /**
   * condition component is..
   */

  const Content__condition = ({ content }) => (
    <Condition>
      {content}
    </Condition>
  )
  
  export default Content__condition


  Content__condition.propTypes = {
    /**
      A custom style object
      */
    style: PropTypes.object,
  };

  Content__condition.defaultProps = {
    style: {},
  };

  /*
    import Content__condition from 'components/content/condition/content__condition'
    <Content__condition />
  */
  